import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  BankTransactionDirection,
  IBankTransaction,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { Payment } from './payment.model';

export class BankTransaction
  extends BaseModel<BankTransaction, 'BankTransaction'>
  implements IBankTransaction
{
  openBankingTransactionId!: string;
  iban!: string;
  @Type(() => Date)
  paymentDate!: Date;
  partnerName!: string;
  partnerIban!: string | null;
  transactionAmount!: number;
  transactionCurrency!: string;
  transactionDirection!: BankTransactionDirection;
  originalAmount!: number | null;
  originalCurrency!: string | null;
  currencyExchangeRate!: number | null;
  variableSymbol!: string | null;
  specificSymbol!: string | null;
  constantSymbol!: string | null;
  payerReference!: string | null;
  remittanceInformation!: string | null;
  additionalInformation!: string | null;
  bankTransactionCode!: string | null;
  cardNumber!: string | null;
  tradingPartyName!: string | null;
  tradingPartyAddress!: string | null;
  tradingPartyIdentification!: string | null;
  tradingPartyMerchantCode!: string | null;
  payments?: Payment[] | null;

  static override modelName = 'BankTransaction' as const;

  get canPair() {
    return (
      !this.payments ||
      (Array.isArray(this.payments) && this.payments.length === 0)
    );
  }
}
